import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Loader2, Plus } from "lucide-react";

export function Modal({ open, onOpenChange, title, children, onSubmit, busy, submitLabel = "Save", testid }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white sm:max-w-lg" data-testid={testid}>
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">{title}</DialogTitle>
          <DialogDescription className="sr-only">{title} form</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit}>
          <div className="grid grid-cols-2 gap-4 py-2">{children}</div>
          <DialogFooter className="mt-4">
            <button type="button" onClick={() => onOpenChange(false)}
              className="bg-white border border-stone-300 text-stone-700 hover:bg-stone-50 rounded-md px-4 py-2 text-sm transition-colors duration-200">
              Cancel
            </button>
            <button type="submit" disabled={busy} data-testid="modal-submit"
              className="bg-forest hover:bg-forest-900 text-white rounded-md px-4 py-2 text-sm font-medium transition-colors duration-200 flex items-center disabled:opacity-60">
              {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />} {submitLabel}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export function Field({ label, span = 1, children }) {
  return (
    <div className={span === 2 ? "col-span-2" : "col-span-1"}>
      <label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">{label}</label>
      {children}
    </div>
  );
}

const base =
  "w-full bg-white border border-stone-300 rounded-md px-3 py-2 text-sm outline-none focus:border-forest focus:ring-2 focus:ring-forest/15";

export function TextInput(props) {
  return <input {...props} className={base} />;
}

export function SelectInput({ options, ...props }) {
  return (
    <select {...props} className={base}>
      {options.map((o) => (
        <option key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</option>
      ))}
    </select>
  );
}

export function AddButton({ onClick, label = "Add", testid }) {
  return (
    <button onClick={onClick} data-testid={testid}
      className="bg-forest hover:bg-forest-900 text-white rounded-md px-4 py-2 text-sm font-medium transition-colors duration-200 flex items-center gap-2">
      <Plus className="h-4 w-4" /> {label}
    </button>
  );
}
